import styled from "styled-components";
import { FormField } from "@/shared/components";
import CodeInput, { type CodeInputProps } from "./CodeInput";

const Field = styled(FormField)`
	margin-bottom: 24px;
`;

const InputState = styled.div<{ $invalid: boolean }>`
	width: 100%;

	.ant-input {
		box-sizing: border-box;
		border-color: ${(props) => (props.$invalid ? "#e43838" : undefined)};

		&:hover,
		&:focus {
			border-color: ${(props) => (props.$invalid ? "#e43838" : undefined)};
			box-shadow: ${(props) => (props.$invalid ? "0 0 0 2px rgba(228, 56, 56, 0.1)" : undefined)};
		}
	}
`;

interface CodeInputFieldProps extends CodeInputProps {
	error?: string;
	label?: string;
}

/** Code entry with a close, absolutely positioned error that never shifts following actions. */
export const CodeInputField = ({ error = "", label = "Code", ...codeInputProps }: CodeInputFieldProps) => (
	<Field label={label} error={error}>
		<InputState $invalid={Boolean(error)}>
			<CodeInput {...codeInputProps} />
		</InputState>
	</Field>
);
